<template>
  <div>
    <div class="flex flex_end">
      <DashboardSellerCurrencySelect v-if="dashboardFilter.type !== 'buyer'"></DashboardSellerCurrencySelect>
      <AccountSelect style="margin-right: 25px; width: 250px;" :required="true" v-if="dashboardFilter.type === 'buyer'"></AccountSelect>
      <YearSelect style="width: 205px;" :required="true"></YearSelect>
    </div>
  </div>
</template>
<script>
import AccountSelect from "@/components/templates/select/AccountSelect.vue";
import YearSelect from "@/components/templates/select/YearSelect.vue";
import {mapGetters} from "vuex";
import DashboardSellerCurrencySelect from "./DashboardSellerCurrencySelect.vue"

export default {
  props: {},
  components: {
    DashboardSellerCurrencySelect,
    AccountSelect,
    YearSelect
  },
  computed: {
    ...mapGetters({ dashboardFilter: "dashboardFilter" })
  }
};
</script>